import { createStore } from 'vuex'
import authusers from './modules/authusers'
import restaurant from './modules/restaurant'

export default createStore({
    modules: {
        authusers,
        restaurant
    },
})